import { render } from "./Tramite.vue?vue&type=template&id=6c87c1b2&scoped=true"
import script from "./Tramite.vue?vue&type=script&lang=js"
export * from "./Tramite.vue?vue&type=script&lang=js"

import "./Tramite.vue?vue&type=style&index=0&id=6c87c1b2&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c87c1b2"]])

export default __exports__